/* eslint-disable i18next/no-literal-string -- type definitions */
export const AttributeEntityType = {
    IDENTITY: 'identities',
    PARTY: 'parties',
    RESOURCE: 'resources',
    FUNCTION_GROUP: 'function-groups',
    TARGET_SYSTEM: 'target-systems',
    CONNECTOR: 'outbound-connectors',
    REPORT: 'reports',
    ACCESS_PROFILE: 'access-profiles',
    ACCOUNT: 'accounts',
    ENFORCEMENT_OBJECT: 'enforcement-objects',
} as const
export type AttributeEntityType = typeof AttributeEntityType[keyof typeof AttributeEntityType]
/* eslint-enable i18next/no-literal-string */
